import React from 'react'
import GiftContactCard from '../components/Cards/GiftContactCard'
import GiftingProducts from '../components/Container/GiftingProducts'
import Footer from '../components/layout/Footer'
import Navbar from './Navbar'

const GiftStore = () => {
  return (
    <div className='bg-slate-50' >
        <Navbar/>
        <h1 className='text-3xl font-bold py-4 px-2 md:ml-4'>Send a special gift to your loved ones, perfectly gift-wrapped!</h1>
        <div className='w-full lg:p-4  flex'>
     <div className='hidden lg:block w-64 mr-2 '>
       <GiftContactCard/>
     </div>
     <div className=' flex-grow border border-gray-100'>
      <GiftingProducts/>
     </div>
    </div>
    <Footer/>
    </div>
  )
}

export default GiftStore